import { mapState } from 'vuex';
export default {
  name: 'ViewISFMTicketingSuccess',
  data: function () {
    return {
      bg: 'background-image: url(./img/astronaut.gif);background-size: cover; width:300px; height:200px;'
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color']),
    homeLink() {
      return this.$store.state.app.sidebarIconLink || '/home';
    }
  },
  mounted() {
    this.$store.state.app.refreshToolbar += 1;
  },
  methods: {
    getBG() {
      switch (this.CustomTheme) {
        default:
          return this.bg;
      }
    }
  }
};